"use client";
import type { ReactElement } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FontWeight } from "@/theme/typography";
import { CmarkdownLabelText } from "../Cmarkdowntext/CmarkdownLabelText";
import { PERIOD_LABEL_HEIGHT } from "./timeline-constants";
import { TIMELINE_LABEL_TEXT_ALIGN_CENTER, selectTimelinePeriodLabelMaxWidth, } from "./timeline-period-selectors";
export interface TimelinePeriodLabelProps {
    isVisible: boolean;
    label: string;
    labelTop: number;
    sectionColor: string;
}
export function TimelinePeriodLabel({ isVisible, label, labelTop, sectionColor, }: TimelinePeriodLabelProps): ReactElement {
    return (
    <AnimatePresence>
      {isVisible && (<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{
                duration: 0.2,
                delay: 0.3,
                ease: "easeOut",
            }} style={{
                position: "absolute",
                left: "50%",
                top: labelTop,
                transform: "translateX(-50%)",
                lineHeight: `${PERIOD_LABEL_HEIGHT}px`,
                maxWidth: selectTimelinePeriodLabelMaxWidth(),
                overflow: "hidden",
                zIndex: 5,
            }}>
          <CmarkdownLabelText dataElScope="Cmarkdowntimeline/TimelinePeriodLabel" content={label} size={14} weight={FontWeight.Bold} textAlign={TIMELINE_LABEL_TEXT_ALIGN_CENTER} style={{ width: "100%" }} paragraphStyle={{ marginBottom: 0, minWidth: 0, maxWidth: "100%" }} textStyle={{
                color: `${sectionColor}E6`,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                lineHeight: `${PERIOD_LABEL_HEIGHT}px`,
                display: "block",
            }}/>
        </motion.div>)}
    </AnimatePresence>
    );
}
